import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CmsPageLayout } from '@grandvisionhq/bloomreach';

/**
 * This HoC wraps a component in the CmsLayout rendering the header and footer with CMS content.
 * TODO: Ideally this shouldn't need to be a NextPage HoC but rather just a regular React HoC
 *  as it doesn't require getInitialProps, however we can only use it on NextPage level currently.
 *
 * Params:
 * settings - Some opcos require different settings for the header (my-account, cart-button etc)
 * layout - Some pages don't need to render all layout items, you can hide them with this object
 *
 * @usage
 * Re-export from opco:
 *  const settings = {...}
 *  export default withCmsLayout(settings)
 *
 * If you don't require additional settings, just export without passing settings:
 *  export default withCmsLayout()
 *
 * In a page component with default layout:
 *  const Page = () => {}
 *  export default withCmsLayout()(Page)
 *
 * If you need to change the layout settings:
 *  const Page = () => {}
 *  export default withCmsLayout({ header: false, navigation: false })(Page)
 */ function withCmsLayout(settings = {}) {
    return (layout = {})=>(PageComponent)=>{
            const WithCmsLayout = (props)=>{
                const Wrapper = !props.isContentPage ? CmsPageLayout : React.Fragment;
                return /*#__PURE__*/ React.createElement(Wrapper, swcHelpers.extends({}, settings, {
                    layoutSettings: layout
                }), /*#__PURE__*/ React.createElement(PageComponent, swcHelpers.extends({}, props)));
            };
            // Forward getInitialProps
            if (typeof PageComponent.getInitialProps === 'function') {
                WithCmsLayout.getInitialProps = PageComponent.getInitialProps;
            }
            if (process.env.NODE_ENV !== 'production') {
                const displayName = PageComponent.displayName || PageComponent.name || 'Unknown';
                WithCmsLayout.displayName = `WithCmsLayout(${displayName})`;
            }
            return WithCmsLayout;
        }
    ;
}

export { withCmsLayout };
//# sourceMappingURL=with-cms-layout.js.map
